// import api from "@/services/api";
// import apiEndpoints from "@/services/apiEndpoints";

const getDefaultState = () => {
  return {
    reOrderData: {},
    printContens: {}
  };
};

const state = getDefaultState();

const mutations = {
  SAVE_REORDER: (state, reOrderData) => {
    state.reOrderData = reOrderData;
  },
  SAVE_PRINT_DATA: (state, printContens) => {
    state.printContens = printContens;
  },
  CLEAR_ORDER: (state) => {
    state.reOrderData = {}
  },
  CLEAR_PRINT_CONENT: (state) => {
    state.printContens = {}
  }
};

const actions = {
  clearSession({ commit }) {
    commit("CLEAR_ORDER");
    commit("CLEAR_PRINT_CONENT");
  }
};

export default {
  state,
  mutations,
  actions
};
